function cycchooseyear(val){

  if(val == 'Select Year'){
    searchyear ='';
  }else{
    searchyear = val;
	searchmake='';
	searchmodel='';
	cycgetdropdown();
  }
  
}

function cycchoosemake(val){

  if(val == 'Select Make'){
    searchmake ='';
  }else{
    searchmake = val;
	searchmodel='';
	cycgetdropdown();
  }

}

function cycchoosemodelsearch(val){

  if(val == 'Select Model'){
    searchmodel ='';
  }else{
    searchmodel = val;
	window.location ='/pages/search-remote?searchyear=' + searchyear + '&searchmake=' + searchmake + '&searchmodel=' + encodeURIComponent(searchmodel);
  }

}



function cycgetdropdown(){
        var jsel = document.createElement('script');
        jsel.type = 'text/javascript';
        jsel.src = 'https://myaccount.carandtruckremotes.com/cyc/search/populate-search-sp.php?searchyear=' + searchyear + '&searchmake=' + searchmake + '&searchmodel=' + searchmodel;
		
		if (document.getElementById('cyc-ajax-load')){
            document.getElementById('cyc-ajax-load').appendChild (jsel);
        }
}

function cycgetdropdownjs(){
        var jsel = document.createElement('script');
        jsel.type = 'text/javascript';
        jsel.src = 'https://myaccount.carandtruckremotes.com/cyc/search/yearshp.js';
		
		if (document.getElementById('cyc-ajax-load')){
            document.getElementById('cyc-ajax-load').appendChild (jsel);
        }
}

function cycdropdownint(){

  cycgetdropdownjs();
}

function cycdropsearchfind(){
  $(".cycsearchmsg").html('');
  if($(".cycsearchmain .cycsearchyear").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchyear").css("color","#E32028");   
	 $(".cycsearchmsg").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Year</DIV>');
  }
  
  if($(".cycsearchmain .cycsearchmake").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchmake").css("color","#E32028");   
	 $(".cycsearchmsg").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Make</DIV>');
  }
  
  if($(".cycsearchmain .cycsearchmodel").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchmodel").css("color","#E32028");   
	 $(".cycsearchmsg").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Model</DIV>');
  }
  
}
function cycdropsearchfindM(){
  $(".cycsearchmsgm").html('');
  if($(".cycsearchmain .cycsearchyearm").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchyearm").css("color","#E32028");   
	 $(".cycsearchmsgm").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Year</DIV>');
  }
  
  if($(".cycsearchmain .cycsearchmakem").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchmakem").css("color","#E32028");   
	 $(".cycsearchmsgm").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Make</DIV>');
  }
  
  if($(".cycsearchmain .cycsearchmodelm").val().startsWith('Select') == true){
	 $(".cycsearchmain .cycsearchmodelm").css("color","#E32028");   
	 $(".cycsearchmsgm").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Model</DIV>');
  }
  
}

function cyclandingdropsearchfind(){
  if($(".cycsearchboxeslandingcontainer .cycsearchyear").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainer .cycsearchyear").css("color","#E32028");   
  }
  if($(".cycsearchboxeslandingcontainer .cycsearchmake").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainer .cycsearchmake").css("color","#E32028");   
  }
  if($(".cycsearchboxeslandingcontainer .cycsearchmodel").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainer .cycsearchmodel").css("color","#E32028");   
  }	
}
